import template from './deliverables-show.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($mdDialog, $log, deliverable) {
	var vm = this
	vm.$onInit = () => {
		//API methods
		vm.cancel = cancel

		//Scope attributes
		vm.deliverable = deliverable

		activate()
		function activate() {}

		function cancel() {
			close()
		}

		function close() {
			$mdDialog.cancel()
		}
	}
}
